// frontend/src/components/ShareComponent.js
import { api } from '../api';
import { marked } from 'marked';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://quiron.app/api';

// A função de conversão agora é exportada para ser reutilizada
export const convertMarkdownToPlainText = (markdownText) => {
  if (!markdownText) return '';
  const html = marked.parse(markdownText);
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');
  // ... (implementação da conversão de HTML para texto plano)
  const processNode = (node) => {
    let text = '';
    const listSymbols = ['- ', '* ', '• '];
    const traverse = (currentNode, listDepth = 0) => {
      currentNode.childNodes.forEach(child => {
        switch (child.nodeName) {
          case 'P':
          case 'H1':
          case 'H2':
          case 'H3':
          case 'H4':
          case 'H5':
          case 'H6':
            traverse(child, listDepth);
            text += '\n\n';
            break;
          case 'UL':
          case 'OL':
            traverse(child, listDepth + 1);
            text += '\n';
            break;
          case 'LI':
            text += '  '.repeat(listDepth) + listSymbols[listDepth % listSymbols.length];
            traverse(child, listDepth);
            text += '\n';
            break;
          case 'BR':
            text += '\n';
            break;
          case 'HR':
            text += '--------------------------\n\n';
            break;
          case '#text':
            text += child.textContent;
            break;
          default:
            traverse(child, listDepth);
        }
      });
    };
    traverse(node);
    return text;
  };
  let finalText = processNode(doc.body);
  return finalText.replace(/\n{3,}/g, '\n\n').trim();
};


const downloadFile = (content, filename, mimeType) => {
    const blob = new Blob([content], { type: mimeType });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
};

const getBrandingFooter = (t) => {
    const now = new Date();
    return `\n\n---\n${t('generatedByQuiron')}\nhttps://quiron.app\n${now.toLocaleString()}`;
};

export const handleShareAsTxt = (content, title, t, addNotification) => {
    try {
        const plainTextContent = convertMarkdownToPlainText(content);
        const fullContent = `${title}\n\n${plainTextContent}${getBrandingFooter(t)}`;
        downloadFile(fullContent, `${title.replace(/ /g, '_')}.txt`, 'text/plain;charset=utf-8');
        return true; // Retorna sucesso
    } catch (error) {
        console.error("Erro ao gerar TXT:", error);
        addNotification(t('errorGeneratingTxt', { error: error.message }), 'error');
        return false; // Retorna falha
    }
};

export const handleShareAsPdf = async (content, addNotification, i18n) => {
    try {
        const language = i18n.language.split('-')[0];
        const response = await api.post(`${API_BASE_URL}/export/pdf`, { content, language }, {
            responseType: 'blob',
        });
        
        const disposition = response.headers['content-disposition'];
        let filename = `Quiron_Response_${new Date().toISOString().split('T')[0]}.pdf`;
        
        if (disposition) {
            const filenameMatch = disposition.match(/filename="(.+?)"/);
            if (filenameMatch && filenameMatch[1]) {
                filename = filenameMatch[1];
            }
        }
        
        downloadFile(response.data, filename, 'application/pdf');
        return true; // Retorna sucesso
    } catch (error) {
        console.error("Error exporting as PDF:", error);
        addNotification('Erro ao gerar o PDF. Tente novamente.', 'error');
        return false; // Retorna falha
    }
};